/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import * as R from 'ramda';
import { useQuery } from '@apollo/client';
import GetSimulationDemographyQuery from '../graphql/queries/GetSimulationDemographyQuery.js';

const useGetSimulationDemographyQuery = (args) => {
  const { data, error, loading, refetch } = useQuery(GetSimulationDemographyQuery, args);

  return {
    error,
    loading,
    refetch,
    getSimulationDemography: R.omit(['__typename'], data?.getSimulationDemography_simulation_demography || {})
  };
};

export default useGetSimulationDemographyQuery;
